import { createAction } from '@'
import { SetFormValues } from '@form'
import { SetModalVisible } from '@modal'

export default createAction('OpenCreateUser', (onSuccess = () => {}) => {
    SetFormValues('UserForm', { onSuccess: onSuccess })
    SetModalVisible('UserForm', true)
})
